import { useEffect, useState } from "react";
import { api } from "../api.ts";
import { AvisoError, useAccion } from "./comun.tsx";

interface Clinica { id: string; nombre: string; activa: boolean; aceptada: boolean; version: string | null; en: string | null; por: string | null }
interface Estado { activo: boolean; desde: string | null; version: string; aprobadoPorAbogado: boolean; diasParaAceptar: number; clinicas: Clinica[] }

/** Panel Donna → «Contrato»: activar la aceptación del contrato de encargo de datos y ver qué clínicas ya lo aceptaron. */
export function ContratoPanel() {
  const [e, setE] = useState<Estado | null>(null);
  const [revisado, setRevisado] = useState(false);
  const a = useAccion();
  const cargar = () => api<Estado>("GET", "/api/plataforma/contrato").then(setE).catch(() => undefined);
  useEffect(() => { cargar(); }, []);
  if (!e) return <p className="muted">Cargando…</p>;
  const aceptadas = e.clinicas.filter((c) => c.aceptada).length;
  async function poner(activo: boolean) {
    const r = await a.correr(() => api<unknown>("PUT", "/api/plataforma/contrato", { activo, textoRevisado: revisado }));
    if (r !== undefined) { setRevisado(false); await cargar(); }
  }
  return (
    <section className="card" aria-labelledby="t-contrato-panel">
      <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
        <h2 id="t-contrato-panel" style={{ margin: 0 }}>Contrato de encargo de datos</h2>
        <span className={`chip${e.activo ? "" : " rojo"}`}>{e.activo ? `Activo desde ${e.desde}` : "Apagado"}</span>
      </div>
      <p className="muted" style={{ margin: 0, fontSize: 13 }}>
        Cuando está activo, la administración de cada clínica ve el contrato en Inicio y lo acepta; puede dejarlo para después durante {e.diasParaAceptar} días y luego la pantalla queda abierta. No bloquea el resto del sistema. Versión del texto: <b>{e.version}</b>.
      </p>
      {!e.aprobadoPorAbogado && <div className="aviso">El texto que trae Donna es un <b>borrador</b>: no lo actives hasta que tu abogado lo revise. Si cambias el texto, sube la versión en <code>dominio/src/contrato.ts</code> para que todas las clínicas lo vuelvan a aceptar.</div>}
      <AvisoError error={a.error} />
      {e.activo ? (
        <div><button className="btn" disabled={a.ocupado} onClick={() => { if (confirm("¿Apagar el contrato? Las clínicas dejarán de ver el aviso (lo ya aceptado se conserva).")) poner(false); }}>Apagar</button></div>
      ) : (
        <div className="fila" style={{ flexWrap: "wrap", alignItems: "center" }}>
          <label><input type="checkbox" checked={revisado} onChange={(x) => setRevisado(x.target.checked)} /> Mi abogado revisó y aprobó el texto</label>
          <button className="btn pri" disabled={a.ocupado || !revisado} onClick={() => poner(true)}>Activar</button>
        </div>
      )}
      <h3 style={{ margin: "8px 0 0" }}>Quién lo aceptó ({aceptadas} de {e.clinicas.length})</h3>
      <ul className="lista-abonos">
        {e.clinicas.map((c) => (
          <li key={c.id} className="cumple">
            <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap" }}>
              <span><b>{c.nombre}</b>{!c.activa && <small className="muted"> · desactivada</small>}</span>
              <span className={`chip${c.aceptada ? "" : " rojo"}`}>{c.aceptada ? `Aceptó el ${new Date(c.en!).toLocaleDateString("es-EC")}${c.por ? ` · ${c.por}` : ""}` : c.version ? "Aceptó una versión anterior" : "Sin aceptar"}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
